<template>
	<DjBox>
		<BaseCloudImage
			class="max-w-full rounded-t-2xl overflow-hidden"
			:public-id="photoId"
			:alt="text || title"
			postfix=".jpg"
			:transformation="[{ width: 440, crop: 'scale' }]"
		/>
		<h3 class="m-3 md:m-6 text-lg md:text-xl font-medium">{{ title }}</h3>
		<div class="content-rte m-3 md:m-6" v-if="$slots.default">
			<slot></slot>
		</div>
	</DjBox>
</template>

<script lang="ts">
import { defineComponent } from "vue";

/**
 * DreamJobs box component with photo and rich text editor content
 *
 */
export default defineComponent({
	name: "DjBoxPhotoWithRteV2",
	props: {
		title: {
			default: "",
			required: true,
		},
		photoId: {
			type: String,
			default: "",
			required: true,
		},
		text: {
			type: String,
			default: "",
			required: false,
		},
	},
});
</script>
